import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";

export const FETCH_CURRENT_USER = "saga/packagesSales/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/packagesSales/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/packagesSales/FETCH_CHART_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/packagesSales/FETCH_FILTERS_SUCCESS";

export const SET_PRIMARY_CATEGORIES_LOADING = "saga/packagesSales/SET_PRIMARY_CATEGORIES_LOADING";
export const SET_SECONDARY_CATEGORIES_LOADING =
  "saga/packagesSales/SET_SECONDARY_CATEGORIES_LOADING";
export const SET_PRICING_OPTIONS_LOADING = "saga/packagesSales/SET_PRICING_OPTIONS_LOADING";
export const SET_FILTERS_DIRTY = "saga/packagesSales/SET_FILTERS_DIRTY";
export const SET_CHART_STATUS = "sagas/packagesSales/SET_CHART_STATUS";
export const SET_LOADING = "saga/packagesSales/SET_LOADING";
export const SET_DATES = "saga/packagesSales/SET_DATES";

export const UPDATE_SECONDARY_CATEGORY_SELECTED =
  "sagas/packagesSales/UPDATE_SECONDARY_CATEGORY_SELECTED";
export const UPDATE_ONLY_CHALLENGERS_SELECTED =
  "sagas/packagesSales/UPDATE_ONLY_CHALLENGERS_SELECTED";
export const UPDATE_PRIMARY_CATEGORY_SELECTED =
  "sagas/packagesSales/UPDATE_PRIMARY_CATEGORY_SELECTED";
export const UPDATE_PRICING_OPTION_SELECTED = "sagas/packagesSales/UPDATE_PRICING_OPTION_SELECTED";
export const UPDATE_TABLE_VIEW_SELECTED = "saga/packagesSales/UPDATE_TABLE_VIEW_SELECTED";
export const UPDATE_ONLY_CHALLENGERS = "sagas/packagesSales/UPDATE_ONLY_CHALLENGERS";
export const UPDATE_FILTERS_SUCCESS = "saga/packagesSales/UPDATE_FILTERS_SUCCESS";
export const UPDATE_PERIOD_TYPE = "sagas/packagesSales/UPDATE_PERIOD_TYPE";
export const UPDATE_GROUP_BY = "sagas/packagesSales/UPDATE_GROUP_BY";
export const UPDATE_DATES = "saga/packagesSales/UPDATE_DATES";
export const UPDATE_CHART = "saga/packagesSales/UPDATE_CHART";
export const UPDATE_CUSTOM_RANGE = "sagas/packagesSales/UPDATE_CUSTOM_RANGE";
const UPDATE_SECONDARY_CATEGORY = "sagas/packagesSales/UPDATE_SECONDARY_CATEGORY";
const UPDATE_PRIMARY_CATEGORY = "sagas/packagesSales/UPDATE_PRIMARY_CATEGORY";
const UPDATE_PRICING_OPTION = "sagas/packagesSales/UPDATE_PRICING_OPTION";
const UPDATE_TABLE_VIEW = "saga/packagesSales/UPDATE_TABLE_VIEW";

export const RESET_FILTER_SELECTED = "sagas/packagesSales/RESET_FILTER_SELECTED";
const RESET_FILTER = "sagas/packagesSales/RESET_FILTER";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateSecondaryCategory: createAction(UPDATE_SECONDARY_CATEGORY),
  updatePrimaryCategory: createAction(UPDATE_PRIMARY_CATEGORY),
  updateOnlyChallengers: createAction(UPDATE_ONLY_CHALLENGERS),
  updatePricingOption: createAction(UPDATE_PRICING_OPTION),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updateGroupBy: createAction(UPDATE_GROUP_BY),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watchPackagesSales() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_PRIMARY_CATEGORY, updatePrimaryCategory);
  yield takeLatest(UPDATE_SECONDARY_CATEGORY, updateSecondaryCategory);
  yield takeLatest(UPDATE_PRICING_OPTION, updatePricingOption);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(UPDATE_ONLY_CHALLENGERS, updateOnlyChallengers);
  yield takeLatest(RESET_FILTER, resetFilters);
}

function* checkForActiveToggle() {
  const challengerState = yield select(
    (state) => state.packagesSales.filters.toggles.onlyChallengers.default
  );
  if (challengerState) yield getFiltersByChallengers(challengerState);
}

function* resetFilters() {
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });
  yield checkForActiveToggle();
  try {
    yield fetchChart("CHECK");
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  try {
    yield fetchChart("UPDATE", { type: UPDATE_TABLE_VIEW_SELECTED, payload });
  } catch (error) {
    console.error(error);
  }
}

export function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updatePrimaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload });
  yield updateFilters("Primary", payload);
  yield getOnlyChallengerByFilters();
}

function* updateSecondaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload });
  yield updateFilters("Secondary", payload);
  yield getOnlyChallengerByFilters();
}

function* updatePricingOption({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload });
  yield updateFilters("PricingOption", payload);
  yield getOnlyChallengerByFilters();
}

function* getOnlyChallengerByFilters() {
  const challengerState = yield select(
    (state) => state.packagesSales.filters.toggles.onlyChallengers.default
  );
  const { primary_categories, secondary_categories, pricing_options } = yield select(
    (state) => state.packagesSales.selectedFilters
  );
  const combinedCategories = [...primary_categories, ...secondary_categories, ...pricing_options];

  if (challengerState) {
    let isChallengerCategory = combinedCategories.every((category) => category.challenger === true);
    yield put({ type: UPDATE_ONLY_CHALLENGERS_SELECTED, payload: isChallengerCategory });
  }
}

function* updateOnlyChallengers({ payload }) {
  const groupBy = yield select((state) => state.packagesSales.selectedFilters.group_by.name);
  yield put({ type: UPDATE_ONLY_CHALLENGERS_SELECTED, payload });
  yield getFiltersByChallengers();
  if (groupBy === "Sales Package") {
    yield put({ type: SET_FILTERS_DIRTY, payload: true });
  } else {
    yield updateData({ payload: "UPDATE" });
  }
}

function* getFiltersByChallengers() {
  const { primary_categories, secondary_categories, pricing_options } = yield select(
    (state) => state.packagesSales.filters
  );
  const combinedFilters = { primary_categories, secondary_categories, pricing_options };
  const challengerState = yield select(
    (state) => state.packagesSales.selectedFilters.only_challengers
  );

  let filters = {};
  if (challengerState) {
    for (let filterKey in combinedFilters) {
      let options = combinedFilters[filterKey];
      filters[filterKey] = options.filter((option) => option.challenger === true);
    }
    yield updateTopFilters(filters);
  } else {
    yield updateTopFilters(combinedFilters);
  }
}

function* updateTopFilters(filters) {
  yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload: filters.primary_categories });
  yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload: filters.secondary_categories });
  yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: filters.pricing_options });
}

function* setDates() {
  const endDate = yield select((state) => state.packagesSales.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

export function* fetchCurrentUserData({ payload }) {
  const { useSecondaryCategories } = yield select((state) => state.commonReducer.commonProps);

  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { useSecondaryCategories, ...payload }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();

  try {
    yield fetchFilters();
    yield checkForActiveToggle();
    yield fetchChart("CHECK");
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChart(event, additionalAction) {
  const commonParams = yield getCommonApiParams();

  yield put({ type: SET_CHART_STATUS, payload: event });

  let chartStatus = yield select((state) => state.packagesSales.chartInfo.status);
  let chartError = yield select((state) => state.packagesSales.chartInfo.error);

  if (chartStatus == "idle" || chartError) return;

  if (additionalAction) {
    yield put(additionalAction);
  }

  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  const filterParams = yield select((state) => state.packagesSales.selectedFilters);

  const params = Object.keys(filterParams).map((paramKey) => {
    const value = filterParams[paramKey];
    if (Array.isArray(value) && value.length > 0) {
      return { [paramKey]: value.map((val) => val.id).join(",") };
    } else if (typeof value === "object" && value.id) {
      return { [paramKey]: value.id };
    } else {
      return {
        [paramKey]: typeof value === "string" ? value.toLowerCase() : value
      };
    }
  });
  const filterQueryParams = Object.assign({}, ...params);

  yield getpackagesSalesChart(commonParams, filterQueryParams);
}

function* getCommonApiParams() {
  const {
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => state.packagesSales);
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  return {
    organization_id: organization_id,
    short_url,
    start_date: startDate,
    end_date: endDate
  };
}

export function* fetchFilters() {
  const commonParams = yield getCommonApiParams();

  yield getpackagesSalesFilters(commonParams);
}

export function* updateData({ payload }, additionalAction) {
  try {
    yield fetchChart(payload, additionalAction);
  } catch (error) {
    console.error(error);
  }
}

export function* updateFilters(name, payload) {
  const commonParams = yield getCommonApiParams();

  const values = payload.map((p) => p.id).join(",");

  if (name === "Primary") {
    yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: true });
    yield getpackagesSalesRevenueCategories(commonParams, true, values, false);
  }
  if (name === "Secondary") {
    yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: true });
    yield getpackagesSalesRevenueCategories(commonParams, false, values, false);
  }

  if (name === "PricingOption") {
    yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: true });
    yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: true });
    yield getpackagesSalesRevenueCategories(commonParams, false, values, true);
  }
}

function* getpackagesSalesChart(commonParams, filterQueryParams = "") {
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/packages/packages_sales_chart/get_packages_values",
      {
        ...commonParams,
        ...filterQueryParams
      }
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data.data });
    yield put({ type: SET_CHART_STATUS, payload: "SUCCESS" });
  } catch (error) {
    console.error(error);
  }
}

function* getpackagesSalesFilters(params) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "pages/packages/packages_sales_chart/filters",
      { params }
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });

    const {
      primary_categories = [],
      secondary_categories = [],
      pricing_options = [],
      start_date,
      end_date
    } = response.data.filters || {};

    yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload: primary_categories });
    yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload: secondary_categories });
    yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: pricing_options });

    yield setDates(start_date, end_date);
  } catch (error) {
    console.error(error);
  }
}

function* getpackagesSalesRevenueCategories(
  commonParams,
  isPrimary,
  categoryValues,
  isPricingOption
) {
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/packages/packages_sales_chart/get_revenue_categories",
      {
        ...commonParams,
        [isPricingOption
          ? "pricing_options"
          : isPrimary
          ? "primary_categories"
          : "secondary_categories"]: categoryValues
      }
    );

    if (isPricingOption) {
      yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: false });
      yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: false });
      yield put({
        type: UPDATE_PRIMARY_CATEGORY_SELECTED,
        payload: response.data.primary_categories
      });
      yield put({
        type: UPDATE_SECONDARY_CATEGORY_SELECTED,
        payload: response.data.secondary_categories
      });
    } else {
      if (isPrimary) {
        yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: false });
        yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: false });
        yield put({
          type: UPDATE_SECONDARY_CATEGORY_SELECTED,
          payload: response.data.secondary_categories
        });
        yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: response.data.pricing_options });
      } else {
        yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: false });
        yield put({ type: SET_PRICING_OPTIONS_LOADING, payload: false });
        yield put({
          type: UPDATE_PRIMARY_CATEGORY_SELECTED,
          payload: response.data.primary_categories
        });
        yield put({ type: UPDATE_PRICING_OPTION_SELECTED, payload: response.data.pricing_options });
      }
    }
  } catch (error) {
    console.error(error);
  }
}
